import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'

export default {
	name: 'auto-handover',
	components: {
		VueElementLoading
	},
	data: function() {
		return {
			isLoading: false,
      auditData: []
		}
	},
	created: function() {},
	computed: {},
	filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
    },
  },
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.useremail = userdetail[0].email;
    this.userhubid = userdetail[0].HubId[0]

		this.getAuditData();
	},
	methods: {

		getAuditData(){

			this.isLoading = true;
			this.auditData = [];

			axios({
			  method: 'GET',
			  'url': apiUrl.api_url_hubops + 'getAuditDataforLoginHub?hubId='+this.userhubid,
			  headers: {
				'authorization': 'authkey xB84JJ89Hd25',
			  }
			})
			.then(result => {

			  if (result.data.ResultCode == 100) {

					this.auditData = result.data.AuditDataForLoginHub;
			  }else{
					this.$alertify.error(result.data.ReturnMessage);
			  }

				this.isLoading = false;
			}, error => {

				this.isLoading = false;
			  console.error(error);
				this.$alertify.error(error.ReturnMessage);
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/AutoBagOutConfiguration_v1/Audit/Audit.js